/** @jsxImportSource @emotion/react */
import { Icon } from "@coreai/component-library"
import { css, useTheme } from "@emotion/react";
// import { API_URLS } from "services/config";
import { useNavBarLabelsService } from "../../../services/useNavBarLabelsService";
import {
  Button,  
} from "@coreai/component-library";
import { useLanguage } from "LanguageContext";
import { useEffect, useState } from "react";

function VideoPopUp({ closeVideoPopUp }: { closeVideoPopUp: () => void }) {
    const { t } = useLanguage();
    const theme = useTheme();
    const { navbarLabels } = useNavBarLabelsService();
    const [showBanner, setShowBanner] = useState(false);
    const [dontShowAgain, setDontShowAgain] = useState(false);

  useEffect(() => {
    const cookies = document.cookie.split("; ").reduce<Record<string, string>>((acc, current) => {
      const [key, value] = current.split("=");
      acc[key] = value;
      return acc;
    }, {});
  
    if (!cookies.hideWarningBanner) {
      setShowBanner(true);
    }
  }, []);

  const setCookie = (name: string, value: string, days: number): void => {
    const expires = new Date(Date.now() + days * 864e5).toUTCString(); // 864e5 = 86400000 = ms in 1 day
    document.cookie = `${name}=${value}; expires=${expires}; path=/`;
  };

  const handleClose = () => {
    if (dontShowAgain) {
      setCookie("hideWarningBanner", "true", 365); // 1 year
    }
    setShowBanner(false);
  };

    // Inline styles
    const overlayStyle = css`
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background-color: rgba(24, 24, 27, 0.80);
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        z-index: 10001;
        `;

    const modalStyle = css`
        position: relative;
        width: 80vw;
        height: 80vh;
        max-width: 100%;
        `;

    const closeBtnStyle = css`
        position: absolute;
        top: 15px;
        right: 15px;
        border: none;
        background: none;
        font-size: 45px;
        cursor: pointer;
        color: white;
        `;
    
    const actionWrapperStyle = css`
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 16px;
      margin-top: 24px;
    `;

    const checkboxStyle = css`
      display: flex;
      justify-content: center;
      align-items: center;
      gap: 6px;
    `;

    const titleStyle = css`
      margin-top: 0px;
      color: ${theme.colors.white};
    `;
    const checkboxInputStyle = css`
      width: 18px;
      height: 18px;
      cursor: pointer;
      accent-color: ${theme.colors.primary};
    `;
    

  if (!showBanner) return null;

  return (
    <div className="video-popup-overlay" css={overlayStyle}>
      <span
          className="close-button"
          css={closeBtnStyle}
          tabIndex={1}
          onClick={() => closeVideoPopUp()}
          role="button"
      >
          <Icon
              className=""
              counterLabel="Messages"
              counterValue={99}
              name="x-close"
              size="lg"
          />
      </span>

      <div>
        <div>
        { ((navbarLabels?.type_of_url === 'blob' || navbarLabels?.type_of_url === 'other' ) && navbarLabels?.video_url) &&
          <video css={modalStyle} autoPlay muted controls>
            <source src={navbarLabels?.video_url} type="video/mp4" />
            {t("your_browser_does_not_support_the_video_tag")}
          </video>
        }
        { (navbarLabels?.type_of_url === 'youtube'  && navbarLabels?.video_url) &&        
              <iframe css={modalStyle} src={navbarLabels?.video_url} title="Tutorial Video" frameBorder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowFullScreen></iframe>
        }
        { (navbarLabels?.type_of_url === 'invalid' ) &&        
              <div style={{color:'#fff'}}>{t("NotavalidvideoURL")}</div>
        }      
        </div> 
      </div>
      {navbarLabels?.video_url &&
        <div css={actionWrapperStyle}>
          <div css={checkboxStyle}>
            <input
              id="check"
              type="checkbox"
              checked={dontShowAgain}
              onChange={() => setDontShowAgain(!dontShowAgain)}
              css={checkboxInputStyle}
              tabIndex={3}
            />
            <p css={titleStyle}>{t("do_not_show_again")}</p>
          </div>
          <Button
            color={theme.colors.primary}
            variant={"brand"}
            onClick={() => {closeVideoPopUp(); handleClose();}}
            className="brandPrimaryBtn"
            tabIndex={4}
          >
          {t("Skip")}
          </Button>
        </div>
      }
    </div>
  )
}

export default VideoPopUp